module.exports = __webpack_public_path__ + "img/document.02163d51.svg";